import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function EmployeeNameCell(row) {
  let navigate = useNavigate();

  let user = JSON.parse(localStorage.getItem("user"));
  const [isTimeKeeper, setIsTimeKeeper] = useState(false);
  useEffect(() => {
    user?.roles.includes("TK") && setIsTimeKeeper(true);
  }, [user]);
  return (
    <>
      {isTimeKeeper ? (
        <div>{row?.employeeName}</div>
      ) : (
        <div
          onClick={() => navigate("/employees/view/" + row?.employeeId)}
          style={{ cursor: "pointer", textDecoration: "underline" }}
        >
          {row.employeeName}
        </div>
      )}
    </>
  );
}

export default EmployeeNameCell;
